"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _imagesModule = _interopRequireDefault(require("./images.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcImage(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_imagesModule["default"].image)
  }, /*#__PURE__*/_react["default"].createElement(_lib.Image, {
    alt: props.alt,
    height: props.height,
    fallback: props.fallback,
    placeholder: props.placeholder,
    src: props.src,
    src1: props.src1,
    width: props.width,
    rootClassName: props.rootClassName,
    preview: props.preview
  }));
}
var _default = ArcImage;
exports["default"] = _default;